export const API_BASE_URL = 'https://api.odcloud.kr/api/nts-businessman/v1';

const SERVICE_KEY = '30ac6eceda478a8561b35b93ddba349439af314ec2ace8a5bc288975b3275111';

const validateEndPoint = `/validate?serviceKey=${SERVICE_KEY}`;
const statusEndPoint = `/status?serviceKey=${SERVICE_KEY}`;

async function openApiRequest(endpoint, method = 'GET', body = null , headers = {}) {
    const config = {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...headers,
        },
    };

    if (body) {
        config.body = JSON.stringify(body);
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    
    if (!response.ok) {
        // throw new Error(response.Error);
        // alert(response.text());
    }

    return response;
}

async function validate(body = null, headers = {}) {
    // 국세청 API를 위한 특별한 처리
    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...headers,
        },
        mode: 'cors',
        body: JSON.stringify(body)
    };

    const response = await fetch(`${API_BASE_URL}${validateEndPoint}`, config);
    return response;
}

async function getStatus(body = null, headers = {}) {
    return openApiRequest(statusEndPoint, 'POST', body, headers);
}

const OpenApiRequest = {
    validate,
    getStatus,
    openApiRequest
};

export default OpenApiRequest;